<template>
    <span v-if="isStringMode" v-html="t(item,'working_hours')"></span>
    <ul
        v-else
        class="a-working-hours"
    >
        <li
            v-for="(item, index) in preparedWorkingHours"
            :key="item.date"
        >
            <span v-if="index === 0">I dag</span>
            <span v-else-if="index === 1">I morgen</span>
            <span v-else>
                {{ $moment(item.date).format('ddd D. MMM') }}
            </span>

            <span class="time">{{ item.time || $t('closed','Stengt') }}</span>

        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "AWorkingHours",
    props: {
        item: {
            type: Object,
            required: true,
        },
        formats:{
            type:Object,
            default: () => ({
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                sameElse: 'ddd D. MMM'
            }),
        }
    },
    methods:{
        convertWorkingHours(periods,specialPeriods, daysAhead = 7){

            function addDays(date, days) {
                const result = new Date(date);
                result.setDate(result.getDate() + days);
                return result;
            }

            const date = new Date();
            const itemDate = [];
            let checkDate = date;
            let dayNumber = checkDate.getDay();

            for(let i=0; i<daysAhead; i++) {
                checkDate = date;

                if(i !== 0) {
                    checkDate = addDays(date, i);
                    dayNumber = checkDate.getDay()
                }
                checkDate = checkDate.toJSON().slice(0,10);

                periods && periods.map(function(item) {
                    if(item.openDay === dayNumber){
                        itemDate[i] = {'date': checkDate, 'time': item.closed ? '' : `${item.openPeriods[0].openTime} - ${item.openPeriods[0].closeTime}`};
                    }
                });

                specialPeriods && specialPeriods.map(function(item) {
                    if(item.date === checkDate){
                        itemDate[i] = {'date': checkDate, 'time': item.closed ? '' : `${item.openPeriods[0].openTime} - ${item.openPeriods[0].closeTime}`};
                    }
                })

            }
            return itemDate;
        },
    },
    computed:{
        ...mapGetters(['getMap', 't']),
        isStringMode(){ return typeof this.t(this.item,'working_hours', null) === 'string' },
        openingHoursMode() { return this.item.meta.otg_use_opening_hours; },

        storeOpenPeriods() { return this.item.meta.working_hours_nb; },
        storeSpecialOpenPeriods() { return this.item.meta.otg_special_opening_hours; },

        centerOpenPeriods() { return this.getMap.meta.otg_opening_hours },
        centerSpecialOpenPeriods() { return this.getMap.meta.otg_special_opening_hours; },

        preparedWorkingHours() {
            if (this.openingHoursMode === 0 && Array.isArray(this.centerOpenPeriods) && Array.isArray(this.centerSpecialOpenPeriods)) {
                return this.convertWorkingHours(this.centerOpenPeriods, this.centerSpecialOpenPeriods)
            }

            if (this.openingHoursMode === 1 && Array.isArray(this.storeOpenPeriods) && Array.isArray(this.storeSpecialOpenPeriods)) {
                return this.convertWorkingHours(this.storeOpenPeriods, this.storeSpecialOpenPeriods)
            }
            return [];
        }
    }

}
</script>

<style lang="scss">
@import "theme";
</style>
